import { Injectable } from '@angular/core';
import { FactorModel } from 'src/models/factor.model';
import { TableGroupModel } from 'src/models/tablegroup.model';

import { TableModel } from 'src/models/table.model';
import { RestApiService } from './rest-api.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { StateEnum } from 'src/models/enum/state.enum';
import { ShareDataService } from '../providers/sharedata.service';
import { GroupByService } from '../providers/groupby.service';
import { state } from '@angular/animations';
import { MatSnackBar } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { debug } from 'console';
import { PushNotificationsService } from './push.notification.service';
import { SwPush } from '@angular/service-worker';

@Injectable({
    providedIn: 'root'
})

export class OrderService {
    private connection: signalR.HubConnection;
    tableGroup: TableGroupModel[];
    selectedGroup: TableModel[];
    groupFactors: any[];
    selectedFilter: string;
    factors: FactorModel[];
    selecteditem: any;
    tableCall: string;
    //selecteditem: boolean;
    forbidden: boolean;
    isConnect : boolean;
    constructor(
        private api: RestApiService<any>,
        private spinner: NgxUiLoaderService,
        private share: ShareDataService,
        public grouplist: GroupByService,
        protected _snackBar: MatSnackBar,
        public toastr: ToastrService,
        public router: Router,
        private _notificationService: PushNotificationsService
    ) {
        // this._notificationService.requestPermission();
    }
    // public hubConnection: signalR.HubConnection;
    // public startConnection = () => {
    //     if (!this.connection && !this.isConnect ) {
    //         // this.getSetting();
    //         this.hubConnection = new signalR.HubConnectionBuilder()
    //             .withUrl(this.api.apiUrl + '/TableHub')
    //                .configureLogging(signalR.LogLevel.Trace)
    //             .build();
    //            this.hubConnection.serverTimeoutInMilliseconds = 1000 * 60 * 1.2; // 1 second * 60 * 10 = 10 minutes.
    //         this.hubConnection
    //             .start()
    //             .then(() => { console.log('Connection started'); this.isConnect = true; this.addTransferDataListener(); })
    //             .catch(err => console.log('Error while starting connection: ' + err));
    //     }
    //     this.hubConnection.keepAliveIntervalInMilliseconds = 31104000000;
    //     this.hubConnection
    //         .onclose(() => {
    //             setTimeout(() => {
    //                 if (!this.forbidden) {
    //                     this.isConnect = false;
    //                     this.startConnection();
    //                 }
    //             }, 2000);
    //         });
    // }
    disconnect() {
        if (this.connection) {
            this.connection.stop();
            this.connection = null;
        }
    }

    isEnabled() {
        return Notification.permission == "granted" ? true : false;
    }

    request() {
        this._notificationService.requestPermission();
    }

    notify(t: string, c: string) {
        let data: Array<any> = [];
        data.push({
            title: t,
            alertContent: c,
            tag: "گارسون",
            sound: `${this.share.api.apiUrl}/assets/audio/notification.mp3`,
            dir: "rtl"
        });
        // data.push({
        //   title: "2 Title with badge",
        //   badge: "https://img.icons8.com/plasticine/2x/google-logo.png",
        //   tag: "tag_2"
        // });

        // data.push({
        //   title: "3 Title, badge & body",
        //   alertContent: "Notification body",
        //   badge: "https://img.icons8.com/plasticine/2x/google-logo.png",
        //   tag: "tag_3"
        // });
        // data.push({
        //   title: "4 Tile, badge, body & icon",
        //   alertContent: "Notification body",
        //   badge: "https://img.icons8.com/plasticine/2x/google-logo.png",
        //   icon: "https://avatars1.githubusercontent.com/u/28635252?s=400&v=4",
        //   tag: "tag_4"
        // });
        // data.push({
        //   title: "5 Title, badge, body, icon & image",
        //   alertContent: "Notification body",
        //   badge: "https://img.icons8.com/plasticine/2x/google-logo.png",
        //   icon: "https://avatars1.githubusercontent.com/u/28635252?s=400&v=4",
        //   image: "https://live.staticflickr.com/4134/4897775884_0d3b982b2f_b.jpg",
        //   tag: "tag_5"
        // });
        // data.push({
        //   title: "4 Tile, badge, body & icon",
        //   alertContent: "Notification body - updated!",
        //   badge: "https://img.icons8.com/plasticine/2x/google-logo.png",
        //   icon: "https://avatars1.githubusercontent.com/u/28635252?s=400&v=4",
        //   tag: "tag_4"
        // });
        // data.push({
        //   title: "6 Tile, badge, body & icon",
        //   alertContent: "Notification body - Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        //   badge: "https://img.icons8.com/plasticine/2x/google-logo.png",
        //   icon: "https://avatars1.githubusercontent.com/u/28635252?s=400&v=4",
        //   tag: "tag_6"
        // });
        this._notificationService.generateNotification(data);
    }


    // addTransferDataListener = () => {
    //     this.hubConnection.on('transferNotification', (res: number) => {
    //         // for (let i = 0; i < this.tableGroup.length; i++) {
    //         //   const find = this.tableGroup[i].tables.find(f => f.tableId === res);
    //         //   if (find && find.tableName && find.tableName !== '') {
    //         //     this.tableCall = find.tableName;
    //         //     break;
    //         //   }
    //         // }
    //         const find = this.selectedGroup.find(f => f.tableId === res);
    //         if (find && find.tableName && find.tableName !== '') {
    //             this.request();
    //             this.notify(find.tableName);
    //             this.playAudio();
    //             this.toastr.warning(`${find.tableName} در خواست مراجعه دارد`, 'توجه', { timeOut: 1000000, closeButton: true, positionClass: 'toast-bottom-right', });
    //         }
    //     });
    //     this.hubConnection.on('transferOrderData', (data: FactorModel) => {
    //         if (data.status != 0 && ((this.tableGroup) && (data.status === StateEnum.Save || data.status === StateEnum.SaveMerge))) {
    //             for (let i = 0; i < this.tableGroup.length; i++) {
    //                 const find = this.tableGroup[i].tables.filter(f => f.tableId.toString() === data.tableId && f.branchCode === data.branchCode)[0];
    //                 if ((find)) {
    //                     if (data.tas && data.tas === 1) {
    //                         find.waiterId = null;
    //                         find.waiterName = '';
    //                         find.customerName = '';
    //                         find.time = null;
    //                         find.num = null;
    //                         if (this.share.filterTableList && this.share.tableList) {
    //                             const find = this.share.tableList.find(f => f.tableId.toString() === data.tableId);
    //                             if (!this.share.filterTableList.some(s => find.tableId === s.tableId))
    //                                 this.share.filterTableList.push(find);
    //                         }
    //                         this.filter(this.selectedFilter);
    //                         break;
    //                     } else {
    //                         find.waiterId = data.waiterId;
    //                         find.waiterName = data.waiterName;
    //                         find.customerName = data.customerName;
    //                         find.time = data.time;
    //                         find.num = data.num;
    //                         if (this.share.filterTableList) {
    //                             const findIndex = this.share.filterTableList.findIndex(f => f.tableId === Number(data.tableId));
    //                             if ((findIndex))
    //                                 this.share.filterTableList.splice(findIndex, 1);
    //                         }
    //                         this.filter(this.selectedFilter);
    //                         break;
    //                     }
    //                 }
    //             }
    //             if (this.share.setting?.systemLayer?.hasTabletOrder) {
    //                 this.refreshTableTimeLeft();
    //             }
    //         }
    //         if ((data.id) && data.id !== 0 && (this.groupFactors) && data.status === StateEnum.Add) {
    //             if (!this.groupFactors.some(s => s.key === data.tableId) && data.status === StateEnum.Add) {
    //                 this.factors.push(data);
    //                 this.groupFactors = this.grouplist.groupby(this.factors, 'tableId');
    //                 if (this.groupFactors.length === 1)
    //                     this.selecteditem = this.groupFactors[0].value;
    //             }
    //             else {
    //                 for (let j = 0; j < this.groupFactors.length; j++) {
    //                     if (!this.groupFactors.some(s => s.key === data.tableId)) {
    //                         this.factors.push(data);
    //                         this.groupFactors = this.grouplist.groupby(this.factors, 'tableId');
    //                         break;
    //                     }
    //                     if (this.groupFactors[j].value[0].tableId === data.tableId) {
    //                         if (data.status === StateEnum.Add) {
    //                             this.factors.push(data);
    //                             if (this.selecteditem[0].tableId === data.tableId)
    //                                 this.selecteditem.push(data);
    //                             this.groupFactors = this.grouplist.groupby(this.factors, 'tableId');
    //                             break;
    //                         }
    //                         if (data.status === StateEnum.Deleted || data.status === StateEnum.Save || data.status === StateEnum.SaveMerge) {
    //                             this.groupFactors.splice(j, 1);
    //                             break;
    //                         }
    //                     }
    //                 }
    //                 //if (!this.groupFactors || this.groupFactors.length <= 0) {
    //                 //  this.selecteditem = false;
    //                 //}
    //             }
    //             if (this.share.loginuser && this.share.loginuser.code)
    //                 this.playAudio();
    //         }
    //         this.spinner.stopAll();
    //         this.share.getDigitalMenuCount();
    //     });
    //     this.hubConnection.on('RedirectResult', (data: any) => {
    //         this.router.navigate([`/payment`]);
    //     });
    // }
    filter(event: string) {
        this.selectedGroup = [];
        if (!(event)) {
            this.selectedFilter = 'All';
        } else {
            this.selectedFilter = event;
        }
        switch (this.selectedFilter) {
            case 'All':
                this.selectedGroup = Object.assign([], this.tableGroup[this.share.selectedGroupIndex].tables);
                break;
            case 'Busy':
                this.selectedGroup = Object.assign([], this.tableGroup[this.share.selectedGroupIndex].tables.filter(f => (f.num)));
                break;
            case 'Free':
                this.selectedGroup = Object.assign([], this.tableGroup[this.share.selectedGroupIndex].tables.filter(f => !(f.num)));
                break;
            default:
                this.selectedGroup = Object.assign([], this.tableGroup[this.share.selectedGroupIndex].tables);
                break;
        }
    }
    refreshTableTimeLeft() {
        this.api.getEntity<TableModel[]>('GetTableTimeLeft').subscribe((res: TableModel[]) => {
            if (res && res.length > 0 && this.tableGroup && this.tableGroup.length > 0) {
                for (let i = 0; i < this.tableGroup.length; i++) {
                    res.forEach(el => {
                        const find = this.tableGroup[i].tables.find(f => f.tableId === el.tableId);
                        if (find)
                            find.time = el.time;
                    });
                }
            }
        });
    }
    playAudio() {
        let audio = new Audio();
        audio.src = "../../../assets/audio/alarm.mp4";
        audio.load();
        audio.play();
    }
    playNAudio() {
        let audio = new Audio();
        audio.src = "../../../assets/audio/notification.mp3";
        audio.load();
        audio.play();
    }
    //stopConnection() {
    //    this.hubConnection.stop();
    //}
}
